// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"5875b6ee","290":"f259fddb","323":"66cd75d9","453":"84038b4d"}[chunkId] + ".chunk.js";
};